import React, { Component } from 'react'
import { Modal, Button, message } from 'antd'
import { connect } from 'react-redux';
// import './payModal.css'
import axios from "axios";

const payList = [
    {

    }
]

class DownFileComponent extends Component {
    constructor(props) {
        super(props)
        this.state = {
            payFlag: false,
            userScore: 0,
            exScore: 0,

            isDownloadFlag:false,
        }
    }
    componentDidMount() {
    }
    payForOrder = () => {
        const { userScore, totalScore } = this.props;
        let exScore = parseInt(userScore) - parseInt(totalScore);
        this.setState({
            payFlag: true,
            userScore: userScore,
            exScore: exScore
        })
    }
    forSure = () => {
        const { user, userScore, orderList, totalScore, resourceType } = this.props;
        // console.log("user, userScore, orderList, totalScore", user, userScore, orderList, totalScore);
        let orderIdList = [];
        if (orderList.length > 0 && !this.state.isDownloadFlag) {
            this.setState({isDownloadFlag:true});
            orderList.map(value => {
                let data = {
                    fileName: value.algorithmname + '.zip',
                    // fileSize: value.fileSize,
                    orderCreationUserId: user.userId,
                    // orderDownloadAddr: value.url + `?filename=${value.fileName}`,
                    // resourceType: value.modelname ?'通用数据处理模型':value.modelname,
                    resourceType: typeof(value.modelname) == "undefined" ?'通用工具检验数据':value.modelname,
                    score: value.score
                };
                orderIdList.push(data);
            })
            console.log("软件工具下载订单检查：", orderIdList);
            
            if (userScore >= totalScore) {
                axios({
                    url: global.url.order + '/order/download/save',
                    method: 'post',
                    data: orderIdList
                }).then(res => {
                    // console.log("downFileComponent", res);
                    if (res.data.code === '200') {
                        message.success('恭喜您成功下单！可前往个人中心查看此订单详情。');
                    } else {
                        message.error('下单失败，请检查网络连接……');
                    }
                    this.props.closeDownLoadModal();
                    this.props.clearAlgCheckedList()
                    this.setState({ payFlag: false,isDownloadFlag:false });
                }).catch(err => {
                    console.log(err);
                    message.error('下单失败，请检查网络连接……');
                    this.props.closeDownLoadModal();
                    this.setState({ payFlag: false ,isDownloadFlag:false});
                })
            }
            else {
                message.error('积分不足，无法下单！');
            }
        } else {
            message.error('请先选择订单')
        }
    }
    cancelSure = () => {
        this.setState({
            payFlag: false
        })
    }
    render() {
        const { user, orderList, userScore, totalScore, showDownLoadModalFlag, closeDownLoadModal } = this.props;
        let footer1 = <div className='footer'>
            <div className='footer-text'>
                <div className='footer-font'><span className='footer-num'>{orderList.length}</span>&nbsp;&nbsp;订单</div>
                <div className='footer-font'>共&nbsp;&nbsp;<span className='footer-num'>{totalScore}</span>&nbsp;&nbsp;积分</div>
            </div>
            <div className='footer-button'>
                <Button size='large' onClick={closeDownLoadModal}>取消</Button>
                <Button onClick={this.payForOrder} type="primary" size='large' title={`当前用户积分为：${userScore}，不足以支付下载积分`} disabled={this.returnDownLoadButtonDisabled()}>下载</Button>
            </div>
        </div>
        let footer2 = <div className='footer'>
            <div className='footer-text'>
                <div className='footer-font'>扣除后剩余 {this.state.exScore} 积分</div>
            </div>
            <div className='footer-button'>
                <Button size='large' onClick={this.cancelSure}>取消</Button>
                <Button onClick={this.forSure} type="primary" size='large' disabled={this.state.isDownloadFlag ? true : false}>确定</Button>
            </div>
        </div>
        return (
            <>
                <Modal
                    className='payModal'
                    visible={showDownLoadModalFlag}
                    title='下载订单'
                    footer={footer1}
                    onCancel={closeDownLoadModal}
                >
                    {
                        orderList.map((value, index) => {
                            return <OrderEntity02
                                key={value.id}
                                data={value} resourceType={this.props.resourceType}
                            ></OrderEntity02>
                        })
                    }
                </Modal>
                <Modal
                    className='payModal-sure'
                    visible={this.state.payFlag}
                    onOk={this.forSure}
                    footer={footer2}
                    centered={true}
                    onCancel={this.cancelSure}
                >
                    您目前的积分为 {userScore} ，确定扣除{totalScore}积分下单？
                </Modal>
            </>

        )
    }

    returnDownLoadButtonDisabled = () => {
        const { userScore, totalScore } = this.props;
        // console.log("returnDownLoadButtonDisabled", userScore, totalScore);
        if (userScore >= totalScore) {
            return false;
        }
        else {
            return true;
        }
    }
}

class OrderEntity02 extends React.Component {
    render = () => {
        const { data, resourceType } = this.props;
        // let { pngUrl, fileName, score, productlevel, satelliteid } = this.props.data
        // console.log("data", data);
        return (
            <div className='OrderEntity02-content'>
                {/* <img className='OrderEntity02-img' src={data.url} /> */}
                <div className='OrderEntity02-text'>
                    {/* {resourceType === "算法模型" ? <div className='OrderEntity02-filName'>{data.chsname}</div>
                        : <div className='OrderEntity02-filName'>{data.fileName}</div>} */}
                    <div className='OrderEntity02-filName'>{data.chsname}</div>
                    {/* <div className='OrderEntity02-satelliteId'>{data.id}</div> */}
                    {/* <div className='OrderEntity02-productLevel'>{data.}</div> */}
                </div>
                <div className='OrderEntity02-score'>{data.score}<span className="small_text">&nbsp;积分</span></div>
            </div>
        )
    }
}

const mapState = (state) => ({ //返回值  对应的是  组件的props  
    user: state.userReducer.get('user').toJS()
})
const mapDispatch = (dispatch, ownProps) => ({
})

export default connect(mapState, mapDispatch)(DownFileComponent);




